/* global window: true */
import React from 'react';

import './LoginForm.scss';
import UpsalesLogo from '../../assets/UpsalesLogo';

const LoginForm = () => (
    <div className="wrapper">
        <div className="logo-wrapper">
            <UpsalesLogo />
        </div>

        <div className="login-form">
            <div className="login-form-box">
                <div className="inner-box">
                    <h1>Upsales TV</h1>
                    <div className="bg-image-holder">
                        <div className="bg-image-overlay" />
                        <p className="information">
                            Skapa motivation och visualisera era nyckeltal. <br/>Logga in med samma uppgifter du anger i Upsales.
                        </p>
                        <form action="/api/auth" method="POST">
                            {window.twofa && window.twofa.token ? <fieldset>
                                <label htmlFor="smsKey">
                                    <div className="icon-holder">
                                        <i className="fa fa-cubes fa-lg" />
                                    </div>
                                    <input
                                        autoComplete="off"
                                        type="text"
                                        name="smsKey"
                                        id="smsKey"
                                        placeholder="SMS kod"
                                        autoFocus
                                    />
                                    <input
                                        type="hidden"
                                        name="token"
                                        id="token"
                                        value={window.twofa.token}
                                    />
                                    <input
                                        type="hidden"
                                        name="email"
                                        id="email"
                                        value={window.twofa.email}
                                    />
                                    <input
                                        type="hidden"
                                        name="password"
                                        id="password"
                                        value={window.twofa.password}
                                    />
                                </label>
                            </fieldset> : <fieldset>
                                <label htmlFor="email">
                                    <div className="icon-holder">
                                        <i className="fa fa-at fa-lg" />
                                    </div>
                                    <input
                                        autoComplete="off"
                                        type="text"
                                        name="email"
                                        id="email"
                                        placeholder="Epost"
                                        autoFocus
                                    />
                                </label>
                                <label htmlFor="password">
                                    <div className="icon-holder">
                                        <i className="fa fa-lock fa-lg" />
                                    </div>
                                    <input
                                        autoComplete="off"
                                        type="password"
                                        name="password"
                                        id="password"
                                        placeholder="Lösenord"
                                    />
                                </label>
                            </fieldset>}
                            {window.flash
                                ? <p className="information error">{window.flash}</p>
                                : ''
                            }
                            <label htmlFor="submit">
                                <input type="submit" id="submit" value="Logga in i Upsales TV" />
                            </label>
                            <a
                                className="forgot-password"
                                href="https://power.upsales.com/#/login"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Glömt lösenord?
                            </a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <a
            className="support-link"
            href="https://support.upsales.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            Upsales support
        </a>
    </div>
);

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./client/components/LoginForm/LoginForm.jsx
 **/